import Skeleton from "src/shared/components/layout/skeleton/Skeleton"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { ComentariosTabProps } from "../MantenimientosDetail.type"

const isoDate = /^\d{4}-\d{2}-\d{2}/

const ComentariosTab = ({ comentarios = [], loading = false }: ComentariosTabProps): JSX.Element => {
    const { formatCustomDate } = useFormatDate()

    // el origen puede mandar la fecha en ISO o ya formateada, solo se formatea la primera
    const getFecha = (fecha?: string | null) => {
        if (!fecha) {
            return "-"
        }
        return isoDate.test(fecha) ? formatCustomDate(fecha, "MMM, DD YYYY hh:mm A") : fecha
    }

    if (loading) {
        return (
            <div className="mantto-detail__comments">
                {[1, 2, 3].map((item) => (
                    <div className="mantto-detail__comment mantto-detail__comment--skeleton" key={item}>
                        <Skeleton.Item drawer style={{ height: 20, width: 180 }} />
                        <Skeleton.Item drawer style={{ height: 20, width: 260 }} />
                    </div>
                ))}
            </div>
        )
    }

    if (!comentarios.length) {
        return <p className="mantto-detail__comments__empty">Aún no hay comentarios en este mantenimiento</p>
    }

    return (
        <div className="mantto-detail__comments">
            {comentarios.map((comentario, index) => (
                <div className="mantto-detail__comment" key={comentario.id || index}>
                    <p className="mantto-detail__comment__date">{getFecha(comentario.fecha)}</p>
                    <p className="mantto-detail__comment__text">{comentario.comentario || "-"}</p>
                </div>
            ))}
        </div>
    )
}

export default ComentariosTab
